import { render, staticRenderFns } from "./GraduateOfficerMenu.vue?vue&type=template&id=7f04541d&scoped=true"
import script from "./GraduateOfficerMenu.vue?vue&type=script&lang=js"
export * from "./GraduateOfficerMenu.vue?vue&type=script&lang=js"
import style0 from "./GraduateOfficerMenu.vue?vue&type=style&index=0&id=7f04541d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f04541d",
  null
  
)

export default component.exports